window.addEventListener('load', function () {
  const element = document.querySelector('main')
  if (!element || !element.classList.contains('assessment')) return

  const tabButtons = document.querySelectorAll('.js_tab_trigger .btn')
  const tabContents = document.querySelectorAll('.js_tab_content > div')

  tabButtons.forEach((btn) => {
    btn.addEventListener('click', function () {
      const targetId = this.getAttribute('data-tab')

      // 1. .btnの.is-currentをリセット → 押されたbtnに追加
      tabButtons.forEach((b) => b.classList.remove('is-current'))
      this.classList.add('is-current')

      // 2. .js_tab_content内の直下divの.is-currentをリセット → 該当するdivに追加
      tabContents.forEach((content) => {
        if (content.id === targetId) {
          content.classList.add('is-current')
        } else {
          content.classList.remove('is-current')
        }
      })
    })
  })
})
